const loadMoreJobs = () => {

  const jobButton = document.querySelector('.kirinus-load-more-jobs');

  if (jobButton) {
    let count = 10;
    let allJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry').length;
    let loadJobs = document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-show-jobs');
    let showJobs = document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs');
    let filterLoad = false;

    if (allJobs === parseInt(loadJobs) || allJobs < parseInt(loadJobs) || !document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs')) {
      jobButton.remove();
    }

    if (loadJobs != null) {
      const container = document.querySelector('.kirinus-job-openings-overview-list');
      const items = container.getElementsByClassName('kirinus-job-openings-overview-list-entry');
      for (let i = 0; i < parseInt(loadJobs) && i < items.length; i++) {
        items[i].classList.add('kirinus-job-openings-overview-list-entry__active');
        if (i + 1 === Math.min(parseInt(loadJobs), items.length)) {
          items[i].classList.add('kirinus-job-openings-overview-list-entry__active_last');
        }
      }
    }

    if (showJobs) {
      count = (parseInt(loadJobs) + parseInt(showJobs));
    }

    const countItems = document.querySelectorAll('.kirinus-job-openings-overview-list-entry').length;
    jobButton.addEventListener('click', function () {

      const container = document.querySelector('.kirinus-job-openings-overview-list');
      const items = container.getElementsByClassName('kirinus-job-openings-overview-list-entry');

      if (count > countItems) {
        count = countItems;
      }

      document.querySelectorAll('.kirinus-job-openings-overview-list-entry__active_last').forEach(
          (item) => item.classList.remove('kirinus-job-openings-overview-list-entry__active_last')
      )

      if (showJobs) {
        let getCurrentActiveJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry__active');
        if (getCurrentActiveJobs.length === parseInt(showJobs)) {
          count = (parseInt(loadJobs) + parseInt(showJobs));
        }
      } else {
        count = 10;
      }

      if (document.querySelectorAll('.btn-kirinus-filter:checked').length >= 1) {

        const filterElem = document.querySelector('.kirinus-job-openings-overview-filter');
        const noEmptyStrings = array => array.filter((string) => string !== '');
        const filters = noEmptyStrings(filterElem.getAttribute('data-has-active-filters').split(','));
        const locations = noEmptyStrings(filterElem.getAttribute('data-has-active-location-filters').split(','));
        let currentFilter = noEmptyStrings(filters.concat(locations));

        if (filterElem.hasAttribute('data-and-mode')) {
          currentFilter = noEmptyStrings(filterElem.getAttribute('data-and-mode'));
        }

        let allJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry');
        let countCheckedJobs = 0;
        let lastActiveJob = 0;

        allJobs.forEach((job) => {
          let isFound = job.getAttribute('data-has-filters').split(',').some( ai => currentFilter.includes(ai));

          if (isFound && !job.classList.contains('kirinus-job-openings-overview-list-entry__active')) {
            if (countCheckedJobs < count) {
              job.classList.add('kirinus-job-openings-overview-list-entry__active');
              ++lastActiveJob;
            }
          }

          if (isFound) {
            ++countCheckedJobs;
          }
        });

        let getCurrentActiveJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry__active');
        getCurrentActiveJobs.forEach((item, index) => {
          if (index + 1 === getCurrentActiveJobs.length) {
            item.classList.add('kirinus-job-openings-overview-list-entry__active_last');
          }
        });

        if (countCheckedJobs === getCurrentActiveJobs.length) {
          jobButton.classList.add('d-none');
          count = 10;

          if (showJobs) {
            count = (parseInt(loadJobs) + parseInt(showJobs));
          }
        } else {
          jobButton.classList.remove('d-none');
        }

      } else {
        filterLoad = true;
        for (let i = 0; i < items.length && i < count; i++) {
          if (!items[i].classList.contains('kirinus-job-openings-overview-list-entry__active')) {
            items[i].classList.add('kirinus-job-openings-overview-list-entry__active');
          }

          if (i + 1 === parseInt(count)) {
            items[i].classList.add('kirinus-job-openings-overview-list-entry__active_last');
          }
        }
      }

      if (!jobButton.classList.contains('d-none')) {
        if (count <= countItems) {
          count = parseInt(count) + parseInt(showJobs);
        }
      }

      const allVisible = Array.from(items).every(function (item) {
        return item.classList.contains('kirinus-job-openings-overview-list-entry__active');
      });
      if (allVisible) {
        jobButton.classList.add('d-none');
        count = 10;

        if (showJobs) {
          count = (parseInt(loadJobs) + parseInt(showJobs));
        }
      }
    });
  }
}
export default loadMoreJobs;
